<form [formGroup]="registerForm" (ngSubmit)="onSubmit()">
  <div class="form-group form-label-group">
    <input type="text" id="{{uuid}}-registerInputEmail" class="form-control" formControlName="email" required angulartics2On="focus" angularticsAction="preReg_emailInput_focus" angularticsCategory="preregistration"/>
    <label for="{{uuid}}-registerInputEmail" i18n="Input Label@@register.form.email.label">Email address</label>
    <div *ngIf="registerForm.controls.email.pending" class="spinner sk-fading-circle">
      <div class="sk-circle1 sk-circle"></div>
      <div class="sk-circle2 sk-circle"></div>
      <div class="sk-circle3 sk-circle"></div>
      <div class="sk-circle4 sk-circle"></div>
      <div class="sk-circle5 sk-circle"></div>
      <div class="sk-circle6 sk-circle"></div>
      <div class="sk-circle7 sk-circle"></div>
      <div class="sk-circle8 sk-circle"></div>
      <div class="sk-circle9 sk-circle"></div>
      <div class="sk-circle10 sk-circle"></div>
      <div class="sk-circle11 sk-circle"></div>
      <div class="sk-circle12 sk-circle"></div>
    </div>
    <div *ngIf="isFieldValid('email')" class="invalid-tooltip">
      <div *ngIf="registerForm.controls.email.errors.required" i18n="Error message when no email is provided@@register.form.errors.email.required">Email is required.</div>
      <div *ngIf="registerForm.controls.email.errors.email" i18n="Error message when email is no valid address@@register.form.errors.email.invalid">Email needs to be a valid address.</div>
      <div *ngIf="registerForm.controls.email.errors.emailAlreadyRegistered" i18n="Error message when email address is already taken@@preregister.form.errors.email.alreadyRegistered">Email is already subscribed!</div>
    </div>
  </div>
  <div class="form-group my-4">
   <!--
   <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="registerInputNewsletter" formControlName="newsletter">
      <label class="custom-control-label" for="registerInputNewsletter">Travian Games newsletter</label>
    </div>
    -->
    <div class="custom-control custom-checkbox">
      <input type="checkbox" class="custom-control-input" id="{{uuid}}-registerInputToc" formControlName="toc" angulartics2On="click" angularticsAction="preReg_privacy_toggled" angularticsCategory="preregistration">
      <label class="custom-control-label" for="{{uuid}}-registerInputToc" i18n="Input Label for Terms and Conditions@@register.form.toc.label">I have read and accept the <a href="https://agb.traviangames.com/privacy-en-Arkheim.pdf" target="_blank">privacy policy</a></label>
      <div *ngIf="registerForm.controls.toc.invalid && (registerForm.controls.toc.dirty || registerForm.controls.toc.touched)" class="invalid-tooltip">
        <span i18n="Error message when Terms & Conditions are not accepted@@register.form.errors.toc.required">You have to accept our privacy policy.</span>
      </div>
    </div>
  </div>
  <div class="text-center">
    <div class="btn-primary-container">
      <button type="submit" class="btn btn-primary" angulartics2On="click" angularticsAction="preReg_form_submitted" angularticsCategory="preregistration">
        <span i18n="Register Form Submit button@@register.form.submit.label">Sign Up</span>
      </button>
    </div>
  </div>
</form>
